import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "next-themes";

import App from "./App";
import { queryClient } from "@/lib/query-client";
import { Toaster } from "@/components/ui/sonner";
import { hasMinRole, useAuthStore } from "@/features/auth/store";

import "./index.css";

// React Query Devtools — visible only to admin/owner roles.
// Hides for everyone else; renders below the rest of the tree so it can
// read the auth store.
function AdminDevtools() {
  const role = useAuthStore((s) => s.user?.role);
  if (!hasMinRole(role, "admin")) return null;
  return <ReactQueryDevtools initialIsOpen={false} />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
        <AdminDevtools />
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
